import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=33444e20&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports